import { Component, inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@shared/components/base/base.component';
import { LocalRepository } from '@shared/helper/local-repository';
import { LikeModel } from '@shared/model/customerModels/like-model';
import { FollowStateEnum } from '@shared/model/enum/follow-state-enum';
import { SharedModule } from '@shared/module/shared.module';
import { EImageType } from '@shared/pipes/image.pipe';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-restriction-message-dialog',
    imports: [
        SharedModule,
        MatCheckboxModule,
        MatDialogModule,
        MatBottomSheetModule,
    ],
    templateUrl: './restriction-message-dialog.component.html',
    styleUrl: './restriction-message-dialog.component.scss'
})
export class RestrictionMessageDialogComponent extends BaseComponent implements OnInit {
  private _localRepository = inject(LocalRepository);
  private _dialogRef = inject<MatDialogRef<RestrictionMessageDialogComponent>>(MatDialogRef, { optional: true });
  private _bottomSheetRef = inject<MatBottomSheetRef<RestrictionMessageDialogComponent>>(MatBottomSheetRef, { optional: true });
  dialogData = inject<{
    likedObject: LikeModel;
    restrictType: string;
}>(MAT_DIALOG_DATA, { optional: true });
  bottomSheetData = inject<{
    likedObject: LikeModel;
    restrictType: string;
}>(MAT_BOTTOM_SHEET_DATA, { optional: true });


  private destroy$ = new Subject<void>();
  user!: LikeModel;
  imageType = EImageType;
  isRemoveFollower!: FormControl
  followStateEnum = FollowStateEnum;
  loading = false
  removedUser = false;
  restrictType!: string;

  ngOnInit(): void {
    this.user = this._localRepository.IsInMobile ? this.bottomSheetData?.likedObject! : this.dialogData?.likedObject!;
    this.restrictType = this._localRepository.IsInMobile ? this.bottomSheetData?.restrictType! : this.dialogData?.restrictType!;
  }

  close() {
    if (this._dialogRef) {
      this._dialogRef.close();
    } else if (this._bottomSheetRef) {
      this._bottomSheetRef.dismiss();
    }
  }

 override ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
